import React, { useState } from 'react';
import { FilterOption } from '../../../../types';
import { AvailableFiltersCount } from '../../../../types/oneGraphTypes';

export interface SuggestionType {
  suggestion: string;
}

export const useSearchModels = (
  allOptionsList: string[],
  modelFamilyOptions: {
    [key: string]: AvailableFiltersCount;
  },
) => {
  const [suggestions, setSuggestions] = useState<string[]>([]);
  const [error, setError] = useState<string | null>(null);

  const fetchSuggestions = async (input: string) => {
    if (!input) {
      // If there is no searchTerm return an empty array
      setSuggestions([]);
      return;
    }
    if (!allOptionsList.length) {
      setSuggestions([]);
      return;
    }

    const filteredInput = input.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();

    const searchedSuggestion = allOptionsList.filter((option) => {
      // Use regular expression to keep only alphanumeric characters (letters and numbers), excluding spaces
      // Then change it to lower case
      if (modelFamilyOptions[option].disabled) return false;
      return option.includes(filteredInput);
    });

    if (!searchedSuggestion.length && allOptionsList.includes(filteredInput)) {
      setError(
        'Model not part of your selected body styles. Uncheck body styles or choose another model.',
      );
      setSuggestions([]);
      return;
    }

    // Wrong Input - No models name avaialble for this input
    if (!searchedSuggestion.length) {
      setError(
        "Input provided is not valid. Please enter the correct model name for the vehicle you're searching for.",
      );
      setSuggestions([]);
      return;
    }

    setSuggestions(searchedSuggestion);
  };

  return { suggestions, fetchSuggestions, error, setError };
};
